import { useTheme } from "hooks/useTheme";
import React, { useState, useRef, useEffect, ReactNode } from "react";
import { CiSquarePlus } from "react-icons/ci";

type DropdownOption = {
  label: string;
  onClick: () => void;
  icon: ReactNode;
};

type DropdownMenuProps = {
  options: DropdownOption[];
};

const DropdownMenu: React.FC<DropdownMenuProps> = ({ options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const theme = useTheme();
  return (
    <div
      ref={menuRef}
      style={{
        position: "relative",
        display: "inline-block",
      }}
    >
      {/* Dropdown Menu */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            bottom: "100%",
            marginBottom: "8px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "4px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
            padding: "8px 0",
            minWidth: "160px",
            zIndex: 1000,
          }}
        >
          {options.map((option, index) => (
            <div
              key={index}
              style={{
                padding: "8px 16px",
                cursor: "pointer",
                whiteSpace: "nowrap",
                textAlign: "left",
                backgroundColor: "white",
                transition: "background 0.2s",
                display: "flex",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "white")
              }
              onClick={() => {
                option.onClick();
                setIsOpen(false);
              }}
            >
              <span
                style={{
                  fontSize: "20px",
                  marginRight: 5,
                }}
              >
                {option?.icon}
              </span>
              <p style={{ marginTop: "auto", marginBottom: "auto" }}>
                {option.label}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Trigger Button */}
      <CiSquarePlus
        style={{
          color: theme.primary,
          fontSize: "40px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
        onClick={toggleMenu}
      />
      {/* <button
        onClick={toggleMenu}
        style={{
          padding: "8px 16px",
          backgroundColor: "#007BFF",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Toggle Menu
      </button> */}
    </div>
  );
};

export default DropdownMenu;
